export default __webpack_public_path__ + "static/media/icon-booking-m.4299001f.svg";